export const queryParser = (query) => {
  const params = new URLSearchParams(query);
  return Object.fromEntries(params.entries());
};

export const detectAnalyticsSource = (params) => {
  const pid = (params.pid || '').toLowerCase();
  const utmSource = (params.utm_source || '').toLowerCase();
  const fbclid = params.fbclid;
  const gclid = params.gclid;
  const ttclid = params.ttclid;

  if (
    pid.includes('meta') ||
    utmSource.includes('fb') ||
    utmSource.includes('facebook') ||
    fbclid
  ) {
    return 'facebook';
  }

  if (pid.includes('google') || utmSource.includes('google') || gclid) {
    return 'google';
  }

  if (
    pid.includes('bytedance') ||
    utmSource.includes('bytedance') ||
    utmSource.includes('tiktok') ||
    ttclid
  ) {
    return 'tiktok';
  }

  return null;
};

export const processText = (text) =>
  text.replace(/\n/g, '<br>').replace(/\\n/g, '<br>').replace(/n\\/g, '<br>');
